<div *ngIf="currentITTStep === 1" class="!mt-[-46px]">
  <div
    class="header h-[55px] flex justify-start items-center pl-[14px] mt-[30px] bg-[#F1F3F5]"
  >
    <p class="!m-0 pl-[20px]">{{ projectName }} - {{ labels.title }}</p>
    <p
      class="!mt-[10px] bg-white !ml-[15px] flex items-center justify-center tag"
    >
      Project Brief
    </p>
  </div>
  <div class="p-[21px] !pb-0">
    <app-brief-section></app-brief-section>
  </div>
  <div
    class="relative bottom-0 right-0 !pr-[40px] !mb-[60px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        (click)="nextStep()"
      >
        Next
      </button>
    </div>
  </div>
</div>
<div *ngIf="currentITTStep === 2">
  <!-- we need isEdit on just the first as we create row only in this. in rest we just update it so its already edit -->
  <app-itt-work-packages
    [isEdit]="isEdit"
    [ITTDeveloperData]="ITTDeveloperData"
    (workPackagesDataEmitter)="handleWorkPackagesData($event)"
  ></app-itt-work-packages>
</div>
<div *ngIf="currentITTStep === 3">
  <app-companies-selection
    [ITTDeveloperData]="ITTDeveloperData"
    (companiesSelectionDataEmitter)="handleCompaniesSelectionData($event)"
  ></app-companies-selection>
</div>
<div *ngIf="currentITTStep === 4">
  <app-itt-tender-submission-guidlines
    [ITTDeveloperData]="ITTDeveloperData"
    (tenderSubmissionDataEmitter)="handleTenderSubmissionData($event)"
  ></app-itt-tender-submission-guidlines>
</div>
<div *ngIf="currentITTStep === 5">
  <app-itt-contractual-terms
    [ITTDeveloperData]="ITTDeveloperData"
    (contractualTermsDataEmitter)="handlecontractualTermsData($event)"
  ></app-itt-contractual-terms>
</div>
<div *ngIf="currentITTStep === 6">
  <app-itt-key-dates
    [ITTDeveloperData]="ITTDeveloperData"
    (keyDatesDataEmitter)="handlekeyDatesData($event)"
  ></app-itt-key-dates>
</div>
<div *ngIf="currentITTStep === 7">
  <app-itt-technical-evaluation-weightage
    [ITTDeveloperData]="ITTDeveloperData"
    (technicalEvaluationDataEmitter)="handleTechnicalEvaluationData($event)"
  ></app-itt-technical-evaluation-weightage>
</div>
<div *ngIf="currentITTStep === 8">
  <app-itt-commercial-evaluation-weightage
    (closeModalEvent)="handleCloseModal($event)"
    [ITTDeveloperData]="ITTDeveloperData"
  ></app-itt-commercial-evaluation-weightage>
</div>
